/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './dropdown-item.stache';

Component.extend({
    tag: 'dropdown-item',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            value: {
                value: null
            },
            title: {
                type: 'string',
                value: null
            },
            display: {
                type: 'boolean',
                value: true
            }
        },
    },
    events: {
        'inserted' (element) {
            element.closest('dropdown-container').viewModel().attr('items').push(this.viewModel);

            if (this.viewModel.attr('isAnalytics')) {
                element.find('.s-dropdown-list__item').attr(this.viewModel.attr('analyticsKey'), this.viewModel.attr('title'));
            }
        },
        'removed' (element) {
            let containerItems = element.closest('dropdown-container').viewModel().attr('items');
            let elementIndex = containerItems.indexOf(this.viewModel);
            if (elementIndex !== -1) {
                containerItems.splice(elementIndex, 1);
            }
        }
    }
});